<template>
  <Handle type="target" :position="Position.Left" />
  <Handle id="happy" type="source" :position="Position.Right" />
  <Handle id="unhappy" type="source" :position="Position.Bottom" />

  <v-card class="pa-4 bg-highlight diamond-card" variant="outlined">
    <v-card-text class="diamond-card-text">
      {{ humanify(condition) }}
    </v-card-text>
  </v-card>
  <div class="happy-card-text text-normal font-weight-bold">Yes</div>
  <div class="unhappy-card-text text-caution font-weight-bold">No</div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { Handle, Position } from "@vue-flow/core"
  import { camelCaseToWords } from "@/helpers/stringHelpers"

  export default defineComponent({
    components: { Handle },
    props: {
      condition: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        Position,
      }
    },

    methods: {
      humanify(str) {
        return camelCaseToWords(str.match(/\${\w+\.(\w+)}/)[1].toString() + "?")
      },
    },
  })
</script>

<style scoped>
  .diamond-card {
    width: 100px;
    height: 100px;
    transform: rotate(45deg);
    overflow: hidden;
    position: relative;
  }
  .diamond-card-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    text-align: center;
  }
  .happy-card-text {
    position: absolute;
    top: 20px;
    left: 120px;
    text-align: center;
  }

  .unhappy-card-text {
    position: absolute;
    top: 120px;
    left: 20px;
    text-align: center;
  }
</style>
